export const incomes = [
  {
    label: 'Plans.filter.income.0',
    id: 'employee',
  },
  {
    label: 'Plans.filter.income.1',
    id: 'resico',
  },
  {
    label: 'Plans.filter.income.2',
    id: 'rent',
  },
  {
    label: 'Plans.filter.income.3',
    id: 'platformDigital',
  },
  {
    label: 'Plans.filter.income.4',
    id: 'investments',
  },
  {
    label: 'Plans.filter.income.5',
    id: 'herence',
  },
];

export const services = [
  {
    label: 'Plans.filter.service.0',
    id: 'mailAsesory',
  },
  {
    label: 'Plans.filter.service.1',
    id: 'lowCost',
  },
  {
    label: 'Plans.filter.service.2',
    id: 'payLater',
  },
  {
    label: 'Plans.filter.service.3',
    id: 'callAsesory',
  },
  {
    label: 'Plans.filter.service.4',
    id: 'improveResult',
  },
];
